export const RENTAL_STAGES = {
  GENERAL: 1,
  GALLERY: 2,
  PRICING: 3,
  AVAILABILITY: 4,
  FAQ: 5,
  INCLUSIONS: 6,
  EXCLUSIONS: 7,
  TERMS: 8,
};

export const RENTAL_STAGE_IDS = {
  [RENTAL_STAGES.GENERAL]: "general",
  [RENTAL_STAGES.GALLERY]: "gallery",
  [RENTAL_STAGES.PRICING]: "pricing",
  [RENTAL_STAGES.AVAILABILITY]: "availability",
  [RENTAL_STAGES.FAQ]: "faq",
  [RENTAL_STAGES.INCLUSIONS]: "inclusions",
  [RENTAL_STAGES.EXCLUSIONS]: "exclusions",
  [RENTAL_STAGES.TERMS]: "terms",
};

export const RENTAL_MAX_STAGE = RENTAL_STAGES.TERMS;

export const GENERAL_SAVE_KEYS = [
  "category_id",
  "rental_sub_category_id",
  "feature_ids",
  "title",
  "brand",
  "subtitle",
  "unit_code",
  "seats",
  "fuel_type",
  "transmission",
  "current_km",
  "running_limit",
  "description",
  "location",
  "latitude",
  "longitude",
  "pickup_locations",
  "is_active",
  "quantity",
  "category_attributes",
];

export const mergeGeneralSavePayload = (serverRow, local) => {
  const out = {};
  const loc = local && typeof local === "object" ? local : {};
  GENERAL_SAVE_KEYS.forEach((k) => {
    if (Object.prototype.hasOwnProperty.call(loc, k) && loc[k] !== undefined) {
      out[k] = loc[k];
    } else if (serverRow && serverRow[k] !== undefined) {
      out[k] = serverRow[k];
    }
  });
  if (Object.prototype.hasOwnProperty.call(loc, "rental_sub_category_id")) {
    out.rental_sub_category_id = loc.rental_sub_category_id === "" ? null : loc.rental_sub_category_id;
  }
  out.category_attributes = loc.category_attributes ?? serverRow?.category_attributes ?? {};
  if (Object.prototype.hasOwnProperty.call(loc, "pickup_locations")) {
    out.pickup_locations = loc.pickup_locations;
  } else if (Array.isArray(serverRow?.pickup_locations)) {
    out.pickup_locations = serverRow.pickup_locations;
  }
  return out;
};

export const getTabStage = (tabId, sections) =>
  sections.find((i) => i.id === tabId)?.stage || RENTAL_STAGES.GENERAL;
